// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

export const Data = {
  slides: [
    {
      slug: 'review-started-slide',
      title: '360 Feedback In Motion!',
      imageBgColor: Colors.purple[25],
      image: Illustrations.three_people_sitting_under_a_clock_purple_bg,
      imageWidth: '145px',
      nextBtnLabel: 'Done',
      description: `We’ve created action items to remind people to turn in their feedback. Once they’re all in, we’ll notify you to view them in the Feedback tab.`,
    },
  ],
} as NewFeatureCarouselModalType;
